import { Active, Over } from '@dnd-kit/core';

import { LongHaulTrip } from './types';

/**
 * dnd-kit の `data` に載せる値。`buildBoardCommand` が要る `DraggedItem` / `DropLocation` を
 * `active` / `over` から復元するための入れ物。
 *
 * Why not active.id から引く: 未割当カードは `active.id` が `UnassignedItem.id` なので
 * 呼び出し側の索引で引けるが、バーは複数の legRun を束ねた回転で、id から辿り直すと
 * ボードの組み立てをもう一度やることになる。運行そのものを載せる。
 */
export type TripDragData = { longHaulTrip: LongHaulTrip };

/**
 * ボードの D&D を担う `DndContext` の id。
 *
 * 左カラムに流用している車両リストは、自分の中に車両並べ替え用の `DndContext` を持つ。
 * `DndContext` をスタブに差し替えるテストは最後に描かれたものの props を掴むので、
 * 目印が無いとボードのハンドラではなく車両リストのハンドラを掴む（実際に掴んでいて、
 * D&D の結線テストが「落とせたのに何も起きない」側へ静かに倒れた）。
 */
export const LONG_HAUL_DND_CONTEXT_ID = 'long-haul-board';

export type WorkDropData = { shiftTruckId: number; targetRowId: string };

export const readTripDragData = (active: Active | null | undefined): LongHaulTrip | null => {
  const data = active?.data.current as TripDragData | undefined;
  return data?.longHaulTrip ?? null;
};

export const readWorkDropData = (over: Over | null | undefined): WorkDropData | null => {
  const data = over?.data.current as WorkDropData | undefined;
  if (data?.shiftTruckId == null || data.targetRowId == null) return null;
  return { shiftTruckId: data.shiftTruckId, targetRowId: data.targetRowId };
};
